(() => {
  const panel = document.getElementById('PinoNewsletterCorner');
  if (!panel) return;

  const dismissedKey = 'pino_newsletter_corner_dismissed_at';
  const subscribedKey = 'pino_newsletter_corner_subscribed';
  const dismissForMs = 14 * 24 * 60 * 60 * 1000;
  const showDelayMs = window.matchMedia('(max-width: 749px)').matches ? 120000 : 12000;

  const readStorage = (key) => {
    try { return localStorage.getItem(key); } catch (error) { return null; }
  };
  const writeStorage = (key, value) => {
    try { localStorage.setItem(key, value); } catch (error) {}
  };

  if (readStorage(subscribedKey) === '1') return;
  const dismissedAt = Number(readStorage(dismissedKey) || 0);
  if (dismissedAt && Date.now() - dismissedAt < dismissForMs) return;

  const showPanel = () => {
    panel.hidden = false;
    requestAnimationFrame(() => panel.classList.add('is-visible'));
  };
  const closePanel = () => {
    panel.classList.remove('is-visible');
    writeStorage(dismissedKey, String(Date.now()));
    window.setTimeout(() => { panel.hidden = true; }, 300);
  };

  const closeButton = panel.querySelector('[data-pino-newsletter-close]');
  if (closeButton) closeButton.addEventListener('click', closePanel);
  panel.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePanel();
  });

  window.setTimeout(showPanel, showDelayMs);
})();
